import calculateAttributesTotalHeight from '@modules/order/utils/calculate-attributes-total-height'
import {
  DEFAULT_CONTENT_MIN_HEIGHT,
  PRODUCT_CARD_DIMENSIONS,
  ENHANCED_PRODUCT_CARD_DIMENSIONS,
  PRODUCT_IMAGE_HEIGHT,
  ENHANCED_HIERARCHY_ELEMENT_HEIGHT
} from '@modules/showroom/productCollection/constants/uiConstants'
import { PaginatedHierarchyItemsDataStore } from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsDataStore'
import {
  ItemType,
  PaginatedHierarchyItemsUIStore
} from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsUIStore'
import { productConfiguration } from '@stores/productConfigurationStore'
import { UserPreference, userPreferencesStore } from '@stores/userPreferencesStore'
import { action, autorun, computed, observable, reaction } from 'mobx'

export abstract class DimensionPaginatedHierarchyItemsUIStore<
  T extends PaginatedHierarchyItemsDataStore
> extends PaginatedHierarchyItemsUIStore<T> {
  private dimensionReactions = []
  @observable cardDynamicContentHeight = 100
  @computed get dimensions() {
    return userPreferencesStore.preferences[UserPreference.PRODUCT_CARD_PREFERENCE]?.size
  }

  @computed get isEnhancedViewEnabled() {
    return productConfiguration.enhancedViewEnabled
  }

  @action init() {
    const updateDimensionsFun = () => {
      if (this.dimensions) {
        let newDim: any = {
          [ItemType.INDIVIDUAL]: PRODUCT_CARD_DIMENSIONS[this.dimensions],
          [ItemType.PAGE]: PRODUCT_CARD_DIMENSIONS[this.dimensions]
        }
        if (this.isEnhancedViewEnabled) {
          const newHeight = this.cardDynamicContentHeight + PRODUCT_IMAGE_HEIGHT
          newDim = {
            [ItemType.CATEGORY]: {
              height: ENHANCED_HIERARCHY_ELEMENT_HEIGHT
            },
            [ItemType.INDIVIDUAL]: {
              ...ENHANCED_PRODUCT_CARD_DIMENSIONS[this.dimensions],
              height: newHeight
            },
            [ItemType.PAGE]: {
              ...ENHANCED_PRODUCT_CARD_DIMENSIONS[this.dimensions],
              height: newHeight
            }
          }
        }
        this.updateViewDimensions(newDim)
      }
    }
    // Created autorunner because autorunner stopped working after 3rd change due to strange reasons
    const updateDimAutorunner = autorun(updateDimensionsFun)
    this.dimensionReactions.push(
      reaction(
        () => this.dimensions,
        () => {
          updateDimAutorunner()
          updateDimensionsFun()
        }
      )
    )
    super.init()
  }

  @action destroy() {
    super.destroy()
    this.dimensionReactions.forEach(disposer => disposer())
  }

  @action
  calculateCardHeight = (currentViewConfig = []) => {
    const height = calculateAttributesTotalHeight(currentViewConfig)
    this.cardDynamicContentHeight = (height || DEFAULT_CONTENT_MIN_HEIGHT) + 20
  }
}
